export const CampingHrHeader = () => {
  return (
    <div id="header" className="c-camping-hr-header">
      <img
        src="https://www.camping.hr/cmsassets/cmscss/img/logo-en.png"
        alt="camping.hr"
        className="c-camping-hr-header__logo"
      />
    </div>
  );
};
